import React from "react";

import { useTranslation } from "react-i18next";
import adjustPrice from "../../../Utils/AdjustPrice";
import DonutChart from "../../Dashboard/SoldProducts/Chart";

const sourceColors = ["#085e75", "#5c7f9e", "#99a2c0", "#a382e0", "#d0c8df"];

export const sourceMap = (t) => [
  {
    name: "Poseidon Spa Prospect",
    label: t("Poseidon Spa Prospect"),
    color: "#085e75",
  },
  {
    name: "Poseidon Spa Lead",
    label: t("Poseidon Spa Lead"),
    color: "#5c7f9e",
  },
  {
    name: "Salon Pro ",
    label: t("Salon Pro "),
    color: "#99a2c0",
  },
  {
    name: "Search",
    label: t("Research"),
    color: "#a382e0",
  },
  {
    name: "Contact",
    label: t("Contact"),
    color: "#d0c8df",
  },
];

const ProspectSourceStats = ({ data = {} }) => {
  const { t } = useTranslation("common");
  const sourceMapData = sourceMap(t);

  return (
    <div className="br5 bgWhite soldProductsContainer colAlignC justify-content-between align-items-start w-100">
      <div className="d-flex flex-wrap w-100 px-4 h-100">
        <div className="">
          <div className="p-4 alignH gap-2">
            <span className="text-blue bold quickSand f22">
              {t("Origin / Store Campaign")}
            </span>
          </div>

          <div className="d-flex">
            <DonutChart
              defaultColors={sourceColors}
              data={sourceMapData?.map((item) => data[item?.name] ?? 0)}
              labels={sourceMapData?.map((item) => item?.label ?? 0)}
            />
          </div>
        </div>
        <div className="colAlignC justify-content-between align-items-start gap-3 my-auto px-2 py-4 flex-grow-1">
          {sourceMapData?.map(({ name, color, label }) => {
            const value = data[name] || 0;
            let formattedValue = adjustPrice(value.toFixed(2).toString());

            return (
              <div
                className="alignH justify-content-between w-100 gap-3"
                key={label}
              >
                <div className="alignH gap-2">
                  <span
                    className={`br4 statColor`}
                    style={{ backgroundColor: color }}
                  ></span>
                  <span className="text-customBlack f16 align-self-start normal">
                    {label}
                  </span>
                </div>
                <span
                  className="f15 text-brightGrey"
                  style={{ textAlign: "end" }}
                >
                  {formattedValue.substring(
                    0,
                    formattedValue.split("")?.findIndex((el) => el === ".")
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProspectSourceStats;
